/* template */
<template><mpx-view @touchstart="touchStart" @touchend="touchEnd" class="delete-order-box"><div :style="(contentStyle)" class="content-box"><slot name="content-slot"></slot></div><mpx-view @tap="deleteClick" class="delete-box"><slot name="delete-slot"></slot></mpx-view></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m66af43a9"}'>
.delete-order-box
  width 100vw
  display flex
  overflow-x scroll
  -ms-overflow-style none
  -webkit-overflow-scrolling touch
  overflow -moz-scrollbars-none
  &::-webkit-scrollbar
    display none
    width 0 !important
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import mpx, { createComponent } from '@mpxjs/core'
createComponent({
  options: {
    multipleSlots: true,
  },
  properties: {
    cardData: Object,
  },
  data() {
    return {
      contentStyle: {},
      scrollItemLeft: 0,
      preScrollItmeIndex: 1,
    }
  },
  attached() {

  },
  ready() {
    this.initPosition()
    const contaierBox = document.getElementsByClassName('delete-order-box')
     for(let i = 0; i< contaierBox.length; i++) {
      contaierBox[i].addEventListener('scroll', e => {
        if (this.preScrollItmeIndex !== i) {
          contaierBox?.[this.preScrollItmeIndex]?.scrollTo?.({
            left:  `${this.scrollItemLeft}px`,
          })
        }
        this.scrollItemLeft = e.target.scrollLeft
        this.preScrollItmeIndex = i
      })
    }
  },
  methods: {
    initPosition() {
      const contaierBox = document.getElementsByClassName('delete-order-box')[0]
      const contentBox = document.getElementsByClassName('content-box')[0]
      const initPadding = (contaierBox.offsetWidth - contentBox.offsetWidth) / 2
      this.contentStyle = {
        'margin': `0 ${initPadding}px`,
      }
    },
    deleteClick() {
      mpx.showModal({
        title: '提示', // 提示的标题,
        content: '删除订单后将不能恢复，是否删除订单？', // 提示的内容,
        showCancel: true, // 是否显示取消按钮,
        cancelText: '取消', // 取消按钮的文字，默认为取消，最多 4 个字符,
        cancelColor: '#000000', // 取消按钮的文字颜色,
        confirmText: '确定', // 确定按钮的文字，默认为取消，最多 4 个字符,
        confirmColor: '#FF442D', // 确定按钮的文字颜色,
        success: res => {
          if (res.confirm) {
            this.triggerEvent('deleteOrder', {
              ...this.cardData,
            })
          } else if (res.cancel) {
            console.log('用户点击取消')
          }
        },
      })
    },
    touchStart() {
    },
    touchEnd() {},
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "delete-order66af43a9",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
